import { useTranslation } from 'react-i18next';

import { ToggleGroup, ToggleGroupItem } from '@app/shared/ui/molecules/Common';
import { Gender } from '@app/shared/types/common';

type Variant = 'lightblue' | 'white';

interface GenderToggleProps {
  value: Gender;
  variant?: Variant;
  onChange: (value: Gender) => void;
}

const VARIANT_TO_CLASSES_MAP: Record<Variant, string> = {
  lightblue: 'bg-secondary',
  white: 'bg-white',
};

export function GenderToggle({ value, variant = 'lightblue', onChange }: GenderToggleProps) {
  const { t } = useTranslation();

  return (
    <ToggleGroup
      type="single"
      value={value}
      className={VARIANT_TO_CLASSES_MAP[variant]}
      onValueChange={(val: Gender) => {
        if (val) {
          onChange(val);
        }
      }}
    >
      <ToggleGroupItem value="f" className="text-base" aria-label="Select Female">
        {t('common.female')}
      </ToggleGroupItem>
      <ToggleGroupItem value="m" className="text-base" aria-label="Select Male">
        {t('common.male')}
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
